import { Space } from 'antd';
import { type ColumnType } from 'antd/es/table';
import { get } from 'react-hook-form';
import styled from 'styled-components';

const ExpandedRowWrapper = styled(Space)`
  margin: -6px 0 0 40px;
`;
const Label = styled.div`
  font-size: ${props => props.theme.fontSizeSM}px;
  line-height: 1em;
  color: ${props => props.theme.colorText};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 300;
  padding-bottom: 2px;
`;

export interface ExpandedRowProps<T> {
  columns?: Array<ColumnType<T>>;
  data?: T;
}

export function ExpandedRow<T>(props: ExpandedRowProps<T>) {
  const { columns, data } = props;
  if (!columns || !data) return null;

  return (
    <div>
      <ExpandedRowWrapper size={[24, 10]} wrap>
        {...(props.columns?.map((column, index) => {
          return (
            <Space key={column.key} direction="vertical" size={0}>
              <Label>
                {typeof column.title === 'function' ? null : column.title}
              </Label>
              <div>
                {(column.render?.(
                  get(data, column.dataIndex as any),
                  data,
                  index,
                ) as any) ?? '-'}
              </div>
            </Space>
          );
        }) ?? [])}
      </ExpandedRowWrapper>
    </div>
  );
}
